import { LinearProgress, Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import { _updateEventStats, getEventStats } from "actions/event"
import CountUp from "components/CountUp"
import Spotlight from "components/Spotlight"
import update from "immutability-helper"
import { subscribe, unsubscribe } from "pubsub-js"
import React, { Fragment, PureComponent } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "recompose"
import { ADMIN_EVENT } from "types/pubsub"
import styles from "./styles"
import event from "reducers/event"

let highBidSub
let removeBidSub
let addDonationSub
let handRemoveSub
let fixedPurchaseSub
let rafflePurchaseSub
class EventEarnings extends PureComponent {
  componentDidMount() {
    this.loadData().then(() => {
      this.setState({
        gettingStats: false
      })
      this.props.data.settings.funds.forEach(fund => {
        if (fund === "bid_earnings") {
          // prevent double subscribing
          if (
            !this.state.subscriptions.highBid &&
            !this.state.subscriptions.removeBid
          ) {
            highBidSub = subscribe(
              `${ADMIN_EVENT}::highBid`,
              this.handleHighBid
            )
            removeBidSub = subscribe(
              `${ADMIN_EVENT}::removeBid`,
              this.handleHighBid
            )
            this.setState(
              update(this.state, {
                subscriptions: {
                  highBid: {
                    $set: true
                  },
                  removeBid: {
                    $set: true
                  }
                }
              })
            )
          }
        }

        if (fund === "donation_earnings" || fund === "donation_pledges") {
          // prevent double subscribing
          if (
            !this.state.subscriptions.addDonation &&
            !this.state.subscriptions.removePledge
          ) {
            addDonationSub = subscribe(
              `${ADMIN_EVENT}::addDonation`,
              this.handleAddDonation
            )
            handRemoveSub = subscribe(
              `${ADMIN_EVENT}::removePledge`,
              this.handleRemovePledge
            )
            this.setState(
              update(this.state, {
                subscriptions: {
                  addDonation: {
                    $set: true
                  },
                  removePledge: {
                    $set: true
                  }
                }
              })
            )
          }
        }

        if (fund === "fixed_purchase_earnings") {
          // prevent double subscribing
          if (!this.state.subscriptions.fixedPurchase) {
            fixedPurchaseSub = subscribe(
              `${ADMIN_EVENT}::fixedPurchase`,
              this.handleFixedPurchase
            )
            this.setState(
              update(this.state, {
                subscriptions: {
                  fixedPurchase: {
                    $set: true
                  }
                }
              })
            )
          }
        }

        if (fund === "raffle_purchase_earnings") {
          // prevent double subscribing
          if (!this.state.subscriptions.rafflePurchase) {
            rafflePurchaseSub = subscribe(
              `${ADMIN_EVENT}::rafflePurchase`,
              this.handleRafflePurchase
            )
            this.setState(
              update(this.state, {
                subscriptions: {
                  rafflePurchase: {
                    $set: true
                  }
                }
              })
            )
          }
        }
      })
    })

    // subscribe("GLOBAL::RELOADDATA", this.loadData)
  }
  componentWillUnmount() {
    unsubscribe(highBidSub)
    unsubscribe(removeBidSub)
    unsubscribe(addDonationSub)
    unsubscribe(handRemoveSub)
    unsubscribe(fixedPurchaseSub)
    unsubscribe(rafflePurchaseSub)
  }

  loadData = () => {
    return this.props.dispatch(
      getEventStats(
        this.props.match.params.event_url,
        this.props.data.settings.start_at_zero
      )
    )
  }
  handleHighBid = (msg, data) => {
    let bidNumber = data.current_high_bid - data.prev_high_bid
    this.props.dispatch(_updateEventStats("bid_earnings", bidNumber))
  }

  handleRafflePurchase = (msg, data) => {
    this.props.dispatch(
      _updateEventStats("raffle_purchase_earnings", data.purchase_amount)
    )
  }

  handleFixedPurchase = (msg, data) => {
    this.props.dispatch(
      _updateEventStats("fixed_purchase_earnings", data.purchase_amount)
    )
  }

  handleAddDonation = (msg, data) => {
    let statName = "donation_earnings"
    if (data.paid === 0) {
      statName = "donation_pledges"
    }
    this.props.dispatch(
      _updateEventStats(statName, parseInt(data.donation_amt, 10))
    )
  }

  handleRemovePledge = (msg, data) => {
    this.props.dispatch(_updateEventStats("donation_pledges", data.amount * -1))
  }
  state = {
    gettingStats: true,
    subscriptions: {}
  }
  getEarnings = () => {
    return this.props.data.settings.funds
      .map(statName => this.props.stats[statName])
      .reduce((a, b) => a + b, 0)
  }
  render() {
    const { classes, data, event } = this.props

    const currentCurrencySymbol = event.currencyObj.symbol || "$"

    return (
      <React.Fragment>
        <div
          className={classes.container}
          style={{ height: data.template === "twoColumn" ? "60%" : "100%" }}
        >
          {this.state.gettingStats && (
            <LinearProgress
              classes={{
                colorPrimary: classes.linearColorPrimary,
                barColorPrimary: classes.linearBarColorPrimary
              }}
            />
          )}
          {!this.state.gettingStats && (
            <Fragment>
              <div className={classes.text}>
                <Typography className={classes.titleText}>
                  Amount Raised
                </Typography>
                <Typography className={classes.amountRaised}>
                  <CountUp end={this.getEarnings()} prefix={currentCurrencySymbol} />
                </Typography>
              </div>
              {data.settings.goal !== 0 && (
                <div className={classes.goalBarWrapper}>
                  <div
                    className={classes.goalBar}
                    style={{
                      width: `${(this.getEarnings() / data.settings.goal) *
                        100}%`
                    }}
                  />
                </div>
              )}
            </Fragment>
          )}
        </div>
        {data.settings.spotlight && (
          <div
            style={{
              height: "40%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center"
            }}
          >
            <div style={{ height: "60%" }}>
              <Spotlight data={this.props.data} event={this.props.event} />
            </div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  stats: state.event.stats,
  event: state.event.event
})

export default compose(
  withRouter,
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(EventEarnings)



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/EventEarnings/index.jsx